<template>
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 5px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="90px"
      >
        <el-form-item label="年份" label-width="50px">
          <el-date-picker
            v-model="listQuery.nf"
            type="year"
            size="mini"
            style="width: 150px"
            format="yyyy"
            placeholder="选择年"
            value-format="yyyy"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属部门" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.bmmc"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="节点名称" prop="jdName">
          <el-input
            v-model="listQuery.jdName"
            placeholder="模糊查询"
            clearable
            size="small"
            style="width: 150px"
          />
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #f8ac59;
              border-color: #f8ac59;
            "
            >导出</el-button
          >
          <el-button
            icon="el-icon-refresh"
            size="small"
            class="filter-item"
            style="margin-left: 15px"
            @click="reset"
            >重置</el-button
          >
        </span>
      </el-form>
      <div style="margin: 10px 0">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleEdit"
          style="margin-left: 0px"
          >新增</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          fixed
          label="操作"
          min-width="120"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <div>
              <el-button @click="handleEdit(scope.row)" type="text" size="small"
                >编辑</el-button
              >
              <el-button
                @click="handleDelete(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="分公司"
          prop="bmmc"
          min-width="130px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目名称"
          prop="xmmc"
          min-width="200px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="区域总监"
          prop="reporter"
          :show-overflow-tooltip="true"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.areaDirector }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="节点名称"
          prop="matter"
          min-width="150px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户执行人"
          prop="content"
          min-width="150px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.customName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="我方执行人"
          prop="hbdx"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.companyName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="完成时间"
          prop="yysj"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.completeTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="成果物"
          prop="reason"
          min-width="200px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fname }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="新增/编辑大事记"
        :visible.sync="addDialog"
        width="90%"
        v-if="addDialog"
        id="mx-dialog"
      >
        <Add ref="add" :mxParams="mxParams" @giveFather="getSon"></Add>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSaveAdd">确定</el-button>
          <el-button @click="addDialog = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { getDsjList, exportDsjList, deleteDsj, saveDsj } from "@/api/dsj.js";
import { getBmxxList, getXmxxList } from "@/api/itWeekly";
import { formatMomentDate } from "@/utils/utils";
import Add from "./add.vue";
export default {
  // 列表分页
  name: "dsjList",
  components: { Pagination, Add },

  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      height: 100,
      listQuery: {
        nf: null,
        bmbh: null,
        xmbh: null,
        jdName: null,
        page: 1,
        pageSize: 10,
      },
      listLoading: true,
      params: {
        xmbh: "",
        bmbh: "",
      },
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "DS", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 1, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "", //合同状态，多个,隔开，如1,3
      },
      time: [],
      total: 0,
      list: [],
      bmList: [],
      xmList: [],
      addDialogFlag: false,
      saveFormParams: {
        id: "",
        bmbh: "",
        bmmc: "",
        bz: "",
      },
      saveForm: {
        title: "新增",
      },
      options: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      addDialog: false,
      editDialog: false,
      mxParams: {},
    };
  },
  created() {
    getBmxxList(2, 1).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      this.listQuery.bmbh,
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });

    this.getList();
  },
  methods: {
    getList() {
      if (this.listQuery.bmmc) {
        this.listQuery.bmbh = this.listQuery.bmmc;
      }
      const params = { ...this.listQuery };
      params.bmmc = null;
      getDsjList(params).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        }
      });
    },

    handleChangeBm(i) {
      this.listQuery.bmbh = i;
      getXmxxList(
        this.data2.htlx,
        this.data2.range,
        this.data2.htzt,
        i,
        "1,2,3"
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },

    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm("是否确认删除该条大事记?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteDsj(row.id);
        })
        .then((res) => {
          if (res.code == 0) {
            this.getList();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },

    reset() {
      // 重置
      this.listQuery = {
        ...this.listQuery,
        ...{
          nf: null,
          bmbh: null,
          bmmc: null,
          xmbh: null,
          jdName: null,
        },
      };
    },
    //导出
    handleExport() {
      if (this.listQuery.bmmc) {
        this.listQuery.bmbh = this.listQuery.bmmc;
      }
      const params = { ...this.listQuery };
      exportDsjList(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleChangeTime(value) {
      if (!value) {
        this.listQuery.qsrq = "";
        this.listQuery.jsrq = "";
        return;
      }
      this.listQuery.qsrq = formatMomentDate(value[0]);
      this.listQuery.jsrq = formatMomentDate(value[1]);
    },
    handleAdd() {
      this.addDialog = true;
    },
    handleSaveAdd() {
      this.$refs.add.handleInsert();
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    handleEdit(row) {
      if (row != null) {
        this.mxParams.id = row.id;
      } else {
        this.mxParams.id = null;
      }
      this.addDialog = true;
    },
    getSon(temp) {
      this.addDialog = temp;
      this.editDialog = temp;
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
</style>
